<template>
  <div>
    <v-card>
      <v-card-text>
        <h2 class="text-center black--text text--darken-1 mb-10">
          EL PRERREGISTRO HA SIDO COMPLETADO
        </h2>
        <h3 class="text-center grey--text text--darken-1 mb-10">
          PASE CON LA SECRETARIA DE SU NIVEL PARA COMPLETAR EL PROCESO.
        </h3>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="bachillerato" class="white--text" @click="dialogOtraFicha = true">
          <v-icon class="mr-2">mdi-pencil</v-icon>CAPTURA OTRA FICHA
        </v-btn>
        <v-btn color="warning" class="mr-3 black--text" @click="finalizar">
          <v-icon class="mr-2">mdi-check</v-icon>FINALIZAR
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- ¿CAPTURAR OTRA FICHA? -->
    <v-dialog v-model="dialogOtraFicha" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Capturar otra ficha
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              Para agilizar su captura los datos de <b>contacto</b>, <b>datos familiares</b> y <b>encuesta</b> se conservarán para su siguiente captura, ¿Desea contuar?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn
            class="error"
            dark
            @click="dialogOtraFicha = false"
            >
            <v-icon>mdi-check</v-icon>
          No
          </v-btn>
          <v-btn
            class="bachillerato"
            dark
            @click="dialog = true, dialogOtraFicha = false"
            >
            <v-icon>mdi-check</v-icon>
          SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ¿CAPTURAR OTRA FICHA? -->

    <!-- FORMULARIO OTRA FICHA -->
    <v-dialog v-model="dialog" fullscreen>
      <div id="img">

      
      <ValidationObserver slim v-slot="{ handleSubmit }">
        <v-card>
          <v-card-title class="primary d-flex justify-center pt-10">
            <validation-provider
              name="Nivel"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                solo
                label="Nivel"
                v-model="nivel"
                :error-messages="errors"
                class="shrink mr-2"
                :items="lst_nivel"
                item-value="id"
                item-text="nombre"
                return-object
                @change="obtenerApertura"
              ></v-select>
            </validation-provider>
            <validation-provider
              name="Grado"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                solo
                label="Grado"
                v-model="id_nivel_grado"
                :error-messages="errors"
                class="shrink"
                :items="lst_grados"
                item-value="id_nivel_grado"
                item-text="grado_nombre"
              ></v-select>
            </validation-provider>
          </v-card-title>
          <v-card-subtitle  class="primary">
            <h5 class="text-center title">{{mensaje}}</h5>
          </v-card-subtitle>
          <v-card-text>
            <v-card elevation="0">
              <v-card-text>
                <v-container>
                  <h1>DATOS ASPIRANTE</h1>
                  <v-row>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Nombre"
                        rules="required|max:45"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :error-messages="errors"
                          label="Nombre"
                          v-model="nombre"
                          class="my-mayus"
                          maxlength="45"
                          counter="45"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Primer apellido"
                        :rules="{ required: validarMaterno, max: validarMaterno ? { length: 45 }: false }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :error-messages="errors"
                          label="Primer apellido"
                          v-model="paterno"
                          class="my-mayus"
                          maxlength="45"
                          counter="45"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Segundo apellido"
                        :rules="{ required: validarPaterno, max: validarPaterno ? { length: 45 } : false }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :error-messages="errors"
                          label="Segundo apellido"
                          v-model="materno"
                          class="my-mayus"
                          maxlength="45"
                          counter="45"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Sexo"
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <v-radio-group v-model="mexicano" row :error-messages="errors"> 
                        <v-radio label="MEXICANO" :value="1"></v-radio>
                        <v-radio label="EXTRANJERO" :value="0"></v-radio>
                      </v-radio-group>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="CURP"
                        :rules="{ required : validarMexicano, min: validarMexicano ? { length : 18 } : false }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          label="CURP"
                          v-model="curp"
                          :error-messages="errors"
                          prepend-icon="mdi-help-circle"
                          @click:prepend="abrirCurp"
                          v-mask="'AAAA######XXXXXXXX'"
                          :disabled="mexicano === 0"
                          
                          maxlength="18"
                          counter="18"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Sexo"
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <label>Sexo</label>
                      <v-radio-group v-model="sexo" row class="pt-0 mt-0" :error-messages="errors" >
                        <v-radio label="MASCULINO" :value="'M'"></v-radio>
                        <v-radio label="FEMENINO" :value="'F'"></v-radio>
                      </v-radio-group>
                       </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <validation-provider
                              name="Fecha de nacimiento"
                              rules="required"
                              v-slot="{ errors }"
                            >
                          <v-text-field
                            label="Fecha de nacimiento"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            v-model="fecha_nacimiento"
                            :error-messages="errors"
                          >
                          </v-text-field>
                           </validation-provider>
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="fecha_nacimiento"
                          :max="new Date().toISOString().substr(0, 10)"
                          :active-picker.sync="activePicker"
                          min="1950-01-01"
                          no-title
                          scrollable
                          color="primary"
                          @change="saveDay"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Nacionalidad"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="nacionalidad"
                          label="Nacionalidad(es)"
                          :items="lst_nacionalidades"
                          item-value="id_nacionalidad"
                          item-text="nombre"
                          multiple
                          :error-messages="errors"
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5"></v-divider>

                  <h1 class="mt-10">ESCUELA DE PROCEDENCIA</h1>
                  <v-row>
                    <v-col cols="12" md="8">
                      <validation-provider
                        name="Escuela Procedencia"
                        rules="required|max:45"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          label="Escuela de procedencia"
                          v-model="escuela_procedencia"
                          :error-messages="errors"
                          class="my-mayus"
                          maxlength="45"
                          counter="45"
                        >
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                      <validation-provider
                        name="Ubicacion de Escuela Procedencia"
                        rules="required|max:45"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          label="Ciudad/Estado/País de escuela de procedencia"
                          v-model="lugar_escuela_procedencia"
                          prepend-inner-icon="mdi-map-marker"
                          :error-messages="errors"
                          class="my-mayus"
                          maxlength="45"
                          counter="45"
                        >
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn class="mr-3" color="error" @click="dialog = false" :disabled="loading || block">
                  <v-icon class="mr-2">mdi-close-box</v-icon>SALIR
                </v-btn>
                <v-btn
                  color="secondary"
                  class="black--text"
                  @click="handleSubmit(saveAspirante)"
                  :loading="loading"
                  :disabled="block"
                >
                  <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y
                  GUARDAR
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </ValidationObserver>
      </div>
    </v-dialog>
    <!-- / FORMULARIO OTRA FICHA -->

    <!-- REGISTRO CREADO -->
    <v-dialog v-model="dialogCreate" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Registro actualizado con éxito
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              Se ha enviado tu clave de pre-registro a la cuenta de correo registrado.
            </p>
            <p class="text-justify">Clic en [ACEPTAR] para continuar.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="bachillerato"
            dark
            @click="goToFormulario(), dialog = false,clean()"
            >
            <v-icon>mdi-check</v-icon>
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / REGISTRO CREADO -->
  </div>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
  created() {
    this.getNacionalidades();
    this.obtenerNiveles();
  },
  data: () => ({
    nivel: null,
    lst_nivel: [],
    dialog: false,
    id_precaptura: "", // Get session storage
    id_aspirante: 0,
    id_nivel_grado: null,
    nombre: "",
    paterno: "",
    materno: "",
    mexicano: 1,
    curp: "",
    sexo: '',
    fecha_nacimiento: '',
    nacionalidad: [112], // 112 = Mexicano
    escuela_procedencia: "",
    lugar_escuela_procedencia: "",
    lst_nacionalidades: [],
    lst_grados: [],
    menu: false,
    mensaje:'',

    // Capturar otra Ficha
    dialogOtraFicha: false,
    dialogCreate: false,
    block: false,
    activePicker:null,

    loading: false,
    banners: [
      {
        id: 5,
        activo: false,
        nombre: "maternal",
        imagen: "maternal",
        color: "#F12535",
        titulo: "maternal",
      },
      {
        id: 1,
        activo: true,
        nombre: "preescolar",
        imagen: "preescolar",
        color: "#FFB600",
        titulo: "Preescolar",
      },
      {
        id: 2,
        activo: false,
        nombre: "primaria",
        imagen: "primaria",
        color: "#E75200",
        titulo: "Primaria",
      },
      {
        id: 3,
        activo: false,
        nombre: "secundaria",
        imagen: "secundaria",
        color: "#71CFEB",
        titulo: "Secundaria",
      },
      {
        id: 4,
        activo: false,
        nombre: "bachillerato",
        imagen: "bachillerato",
        color: "#00AFA9",
        titulo: "Bachillerato",
      },
    ],
  }),
  directives: {
    mask,
  },
  methods: {
    clean(){
      this.getNacionalidades();
      this.obtenerNiveles();
      this.nivel= null;
      this.id_aspirante= 0;
      this.id_nivel_grado=0;
      this.nombre="";
      this.paterno="";
      this.materno="";
      this.curp="";
      this.sexo=null;
      this.fecha_nacimiento='';
      this.escuela_procedencia='';
      this.lugar_escuela_procedencia='';

      },
    async saveAspirante() {


      const nivelSeleccionado = this.banners.filter( banner => banner.id === this.nivel )[0];
     
      let id_precaptura_old = this.$ls.get("id", 0);
      let nivel =  this.nivel.nombre.toUpperCase();
     
      let grado = this.lst_grados.find( ( i ) => ( i.id_nivel_grado === this.id_nivel_grado ) ).grado_nombre
      
      let {
        id_nivel_grado,
        nombre,
        paterno: primer_apellido,
        materno: segundo_apellido,
        mexicano,
        curp,
        sexo,
        fecha_nacimiento,
        nacionalidad,
        escuela_procedencia,
        lugar_escuela_procedencia,
      } = this.$data;

      this.loading = true;
      let { data: { id, folio }, status } = await axios.post("precaptura/otro", {
        id_precaptura_old,
        id_nivel_grado,
        nivel,
        grado,
        nombre,
        primer_apellido,
        segundo_apellido,
        mexicano,
        curp,
        sexo,
        fecha_nacimiento,
        nacionalidad,
        escuela_procedencia,
        lugar_escuela_procedencia,
      });
      if ( id != 0 && folio != '' ) {
        
        this.loading = false;
        this.block = false
        this.dialogCreate = true;
        //this.$ls.clear()
        //this.clean();
      }

    },
    saveDay(date) {
      this.$refs.menu.save(date);
    },

    /**
     *  @description
     */
    async getNacionalidades() {
      let { data } = await axios.get(
        "nacionalidades"
      );
      this.lst_nacionalidades = data;
    },

    abrirCurp() {
      window.open("https://www.gob.mx/curp/");
    },

    obtenerApertura() {
      this.id_nivel_grado = null
      this.mensaje =''
      axios
        .get("apertura/" + this.nivel.id)
        .then(({ data, status }) => {
          this.mensaje = data.mensaje
          if (data.grados.length > 0) {
            this.lst_grados = data.grados;
            
          }
        })
        .catch((error) => console.error(error))
        .finally((this.aperturaObteniendo = false));
    },
       obtenerNiveles() {

      axios
        .get("apertura/niveles")
        .then(({ data, status }) => {
          if (status === 200) this.lst_nivel = data;

          //console.log(data);
        })
        .catch((error) => console.error(error))
        .finally(

        );
    },
    goToFormulario(){
      this.dialogCreate = false
      this.dialog = false
     // this.$ls.clear()
      // this.$router.push({ name: "formulario" });
    },
    finalizar() {
      axios.put( "precaptura/" + this.$ls.get("id", 0 ) )
      .then()
      .catch( ( error ) => console.error( error ))
      this.$ls.clear();
      this.$router.push({ name: "Home" });
    },
  },

  watch: {
    menu(val) {
      // val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    curp(val) {
      this.curp = this.curp.toUpperCase()
    },
    mexicano() {
      if ( this.mexicano === 0 ) {
        this.curp = ''
        this.nacionalidad = []
      } else {
        this.nacionalidad = [112]
      }
    }
  },
  computed: {

    validarPaterno() {

      return ( this.paterno === '' )

    },
    validarMaterno() {

      return ( this.materno === '' )

    },
    validarMexicano() {

      return (this.mexicano === 1);

    }
  }
};
</script>
<style>
#img {
  background-image: url('~@/assets/img/background.jpg');
  background-size: auto 100%;
  background-position: center top;
}
</style>